import React, { useEffect, useState } from "react";
import JoinLive from "./JoinLive";
import { useParams } from "react-router-dom";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
export default function JoinLivePage() {
  const { streamId } = useParams();
  const [playbackUrl, setPlaybackUrl] = useState(null);
  const [streamer, setStreamer] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("accessToken");
    fetch(`${API_BASE_URL}/live/status/${streamId}`, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.result?.playback_url) {
          setPlaybackUrl(data.result.playback_url);
          setStreamer(data.result.user);
        } else {
          console.error("Stream not found");
        }
      })
      .catch((err) => console.error("Fetch stream error:", err));
  }, [streamId]);

  return playbackUrl ? (
    <JoinLive playbackUrl={playbackUrl} streamer={streamer} />
  ) : (
    <div className="text-white flex justify-center items-center h-screen">
      Loading live stream...
    </div>
  );
}
